import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import Vue from 'vue';
import VueRouter from 'vue-router';
import { SnackType } from '@/interfaces/snack';
import { showNotification } from '@/utils/snack';
Vue.use(VueRouter);
var routes = [{
  path: '/',
  name: 'Home',
  redirect: '/goods'
}, {
  path: '/signin',
  name: 'SignIn',
  component: function component() {
    return import('@/views/SignIn.vue');
  }
}, {
  path: '/goods',
  name: 'GoodsList',
  component: function component() {
    return import('@/views/GoodsList.vue');
  }
}, {
  path: '/goods/:id',
  name: 'GoodsDetail',
  component: function component() {
    return import('@/views/GoodsDetail.vue');
  }
}, {
  path: '/editgoods/:id?',
  name: 'EditGoods',
  component: function component() {
    return import('@/views/EditGoods.vue');
  },
  meta: {
    requiresAuth: true,
    rights: ['ROOT', 'ADMIN']
  }
}, {
  path: '/orders',
  name: 'OrderList',
  component: function component() {
    return import('@/views/OrderList.vue');
  }
}, {
  path: '/order/:id',
  name: 'OrderDetail',
  component: function component() {
    return import('@/views/OrderDetail.vue');
  }
}, {
  path: '/editorder/:id?',
  name: 'EditOrder',
  component: function component() {
    return import('@/views/EditOrder.vue');
  }
}, {
  path: '/refundOrder',
  name: 'RefundOrder',
  component: function component() {
    return import('@/views/OrderRefund.vue');
  }
}, {
  path: '/audit',
  name: 'RefundAudit',
  component: function component() {
    return import('@/views/RefundAudit.vue');
  }
}, {
  path: '/refunds',
  name: 'RefundList',
  component: function component() {
    return import('@/views/RefundList.vue');
  }
}, {
  path: '/schools',
  name: 'SchoolList',
  component: function component() {
    return import('@/views/SchoolList.vue');
  }
}, {
  path: '/school/:id',
  name: 'SchoolDetail',
  component: function component() {
    return import('@/views/SchoolDetail.vue');
  }
}, {
  path: '/editschool/:id?',
  name: 'EditSchool',
  component: function component() {
    return import('@/views/EditSchool.vue');
  },
  meta: {
    requiresAuth: true,
    rights: ['ROOT', 'ADMIN']
  }
}, {
  path: '/dealers',
  name: 'DealerList',
  component: function component() {
    return import('@/views/DealerList.vue');
  }
}, {
  path: '/editdealer/:id?',
  name: 'EditDealer',
  component: function component() {
    return import('@/views/EditDealer.vue');
  },
  meta: {
    requiresAuth: true,
    rights: ['ROOT', 'ADMIN']
  }
}, {
  path: '/dealer/:id/detail',
  name: 'DealerDetail',
  component: function component() {
    return import('@/views/DealerDetail.vue');
  }
}, {
  path: '/dealer/:id/goods',
  name: 'EditDealerGoods',
  component: function component() {
    return import('@/views/DealerDetail/pages/EditDealerGoods.vue');
  },
  meta: {
    requiresAuth: true,
    rights: ['ROOT', 'ADMIN']
  }
}, {
  path: '/dealer/:id/school',
  name: 'EditDealerSchool',
  component: function component() {
    return import('@/views/DealerDetail/pages/EditDealerSchool.vue');
  },
  meta: {
    requiresAuth: true,
    rights: ['ROOT', 'ADMIN']
  }
}, {
  path: '/members',
  name: 'MemberList',
  component: function component() {
    return import('@/views/MemberList.vue');
  },
  meta: {
    requiresAuth: true,
    rights: ['ROOT', 'ADMIN']
  }
}, {
  path: '/member/:id',
  name: 'MemberDetail',
  component: function component() {
    return import('@/views/MemberDetail.vue');
  },
  meta: {
    requiresAuth: true,
    rights: ['ROOT', 'ADMIN']
  }
}, {
  path: '/changePassword',
  name: 'ChangePassword',
  component: function component() {
    return import('@/views/ChangePassword.vue');
  }
}, {
  path: '/managers',
  name: 'ManagerList',
  component: function component() {
    return import('@/views/ManagerList.vue');
  },
  meta: {
    requiresAuth: true,
    rights: ['ROOT', 'ADMIN']
  }
}, {
  path: '/subscriptionCycle',
  name: 'SubscriptionCycle',
  component: function component() {
    return import('@/views/SubscriptionCycle.vue');
  },
  meta: {
    requiresAuth: true,
    rights: ['ROOT', 'ADMIN']
  }
}, {
  path: '/profitSharings',
  name: 'ProfitSharingsList',
  component: function component() {
    return import('@/views/ProfitSharingsList.vue');
  }
}];
var router = new VueRouter({
  routes: routes
});
router.beforeEach(function (to, from, next) {
  if (to.name !== 'SignIn' && !localStorage.getItem(process.env.VUE_APP_LOCAL_STORAGE_KEY)) {
    next({
      name: 'SignIn'
    });
  } else {
    var role = sessionStorage.getItem('role');

    if (to.meta.requiresAuth) {
      if (role !== 'DEALER') {
        next();
      } else {
        showNotification({
          msg: '无权限访问',
          type: SnackType.Error
        });
        next({
          path: from.path
        });
      }
    } else {
      next();
    }
  }
});
export default router;